import { useGLTF } from '@react-three/drei'
import { useEffect, useLayoutEffect } from 'react'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { useLoader, useFrame } from '@react-three/fiber'
import { useMemo } from 'react'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import * as THREE from 'three'
import { Vector2 } from 'three'
import { useMontage } from '../../../context/montage.context'

const shadowRecievers = [
  'Material #119',
  'Material #120',
  'Grau lampe.001',
  'Grau lampe',
  'Material #120.002',
  'Material #6',
  'Lack sofa.004',
  // "Fenster glass",
  'Lack sofa.002',
  'Lack sofa.001',
  'Material #121.001',
  'Material #146',
  'Material #121.002',
  'Material #120.001',
  'Material #4',
  'Material #5',
  'Material #5.002',
  'Material #5.001',
  'Grau',
  'Material #118',
  'Material #118.001',
  'Fassade weiß',
  'Grau lampe.002',
  'Erde neu.002',
  'Material.002',
  'Erde neu',
  'Erde neu.003',
  'Erde neu.004',
  'Material.003',
  'Lack sofa',
  'Stoff sofa',
  'Material #24',
  'Material #25',
  'Hecke 1',
  'Hecke alpha',
  'Boden_Gras',
]

const shadowCasters = [
  'Material #119',
  'Material #120',
  'Grau lampe.001',
  'Grau lampe',
  'Material #120.002',
  'Material #6',
  'Lack sofa.004',
  // "Fenster glass",
  'Lack sofa.002',
  'Lack sofa.001',
  'Material #121.001',
  'Material #146',
  'Material #121.002',
  'Material #120.001',
  'Material #4',
  'Material #5',
  'Material #5.002',
  'Material #5.001',
  'Grau',
  'Material #118',
  'Material #118.001',
  'Fassade weiß',
  'Grau lampe.002',
  'Erde neu.002',
  'Material.002',
  'Erde neu',
  'Erde neu.003',
  'Erde neu.004',
  'Material.003',
  'Lack sofa',
  'Stoff sofa',
  'Material #24',
  'Material #25',
  'Hecke 1',
  'Hecke alpha',
  'Boden_Gras',
]

export const House = () => {
  const { scene, materials } = useGLTF(
    `model/house/Haus_V20.glb`,
    true,
    true
  ) as GLTF & any
  /**
   * !because we have 2 canvases for screenshotting, models need to be duplicated
   * https://github.com/pmndrs/react-three-fiber/issues/245
   */
  const clonedScene = useMemo(() => scene.clone(), [scene])
  const clonedMaterialFacade = useMemo(
    () => materials['Fassade weiß'].clone(),
    [materials['Fassade weiß']]
  )
  const { environment } = useMontage()

  const [colorMap, roughnessMap] = useLoader(TextureLoader, [
    'texture/house/Bricks051_1K_Color.jpg',
    'texture/house/Bricks051_1K_Roughness.jpg',
  ])
  const arr = [colorMap, roughnessMap]

  useLayoutEffect(() => {
    if (environment?.facade === 'Verklinkert') {
      setFassadeMaterial(arr)
      Object.assign(materials['Fassade weiß'], {
        //roughnessMap: roughnessMap,
        map: colorMap,
        envMapIntensity: 1,
        roughness:1,
        color: new THREE.Color(0xa8a39e),
      })
    } else {
      Object.assign(materials['Fassade weiß'], {
        roughnessMap: null,
        map: clonedMaterialFacade.map,
        color: clonedMaterialFacade.color,
      })
    }
    clonedScene.traverse((obj: any) => {
      if (obj.isMesh && hasOneMaterialName(obj, shadowRecievers)) {
        obj.receiveShadow = true
      }
      if (obj.isMesh && hasOneMaterialName(obj, shadowCasters)) {
        obj.castShadow = true
      }
    })
   
  }, [clonedScene, colorMap, roughnessMap, environment?.facade])

  return (
    <group position={[-2, -0.05, -2.738]}>
      <primitive object={clonedScene}></primitive>
    </group>
  )
}

export const hasOneMaterialName = (obj: any, materials: string[]) => {
  return materials.includes(obj.material.name)
}

const setFassadeMaterial = (map: any) => {
  map.forEach((m: any) => {
    m.wrapS = THREE.RepeatWrapping
    m.wrapT = THREE.RepeatWrapping
    m.rotation = 1.565
    m.repeat.set(0.5, 0.5)
  })
}
